module.exports = __webpack_public_path__ + "img/shigongzhong.0cc2c272.png";